// OrdenServicioTraslado.actions.ts
import { queryClient } from '@/shared/query-client/query-client';
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { UseFetchEnabledParams, UseMutationsParams, UseUpdateParams } from "@/shared/interfaces";
import { urlBackend } from "@/shared/constants";
import { erpApi } from "@/shared/axios";
import { getUrlParamsFetch } from "@/shared/utils";
import { toApiError } from "@/shared/utils/general";
import { OrdenServicioTraslado, OrdenServicioTrasladoForm, OrdenServicioTrasladoPagingResp, OrdenServicioTrasladoParams } from '@/erp/orden-servicio/orden-servicio-traslado';

const { get, post, put } = erpApi();

const BASE_URL = `${urlBackend}api/v1/orden-servicio/traslado`;

// get

export const useFetchGetOrdenServicioTraslado = ({
  enabled = true,
  params,
}: UseFetchEnabledParams<OrdenServicioTrasladoParams> = {}) => {
  return useQuery({
    queryKey: ['traslado', ...Object.values(params ?? {})],
    queryFn: () => getOrdenServicioTraslado(params),
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
};

export const getOrdenServicioTraslado = async (
  params?: OrdenServicioTrasladoParams
) => {
  const queryParams = getUrlParamsFetch(params ?? {});
  return get<OrdenServicioTrasladoPagingResp>(`${BASE_URL}/?${queryParams}`, true);
};

// create

export const useFetchPostOrdenServicioTraslado = ({
  returnUrl,
  navigate
}: UseMutationsParams = {}) => {

  return useMutation({
    mutationFn: (data: OrdenServicioTrasladoForm) => {
      return postOrdenServicioTraslado(data)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['traslado']
      });

      navigate && returnUrl && navigate(returnUrl);

      toast.success(data.message);

    },
    onError: ((error) => {
      const data = toApiError(error)
      toast.error(data.message)
    }),
    onSettled: () => {

    },
  });
};

export const postOrdenServicioTraslado = async (data: OrdenServicioTrasladoForm) => {
  return await post<OrdenServicioTraslado>(`${BASE_URL}/`, data, true);
};

// filter by id

export const useFetchGetByIdOrdenServicioTraslado = (id: string, enabled: boolean = false) => {
  return useQuery({
    queryKey: ['traslado', id],
    queryFn: async () => {
      return getByIdOrdenServicioTraslado(id);
    },
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
};

export const getByIdOrdenServicioTraslado = async (id: string) => {
  const res = await get<OrdenServicioTraslado>(`${BASE_URL}/${id}`, true);
  return res;
};

// update

export const useFetchPutOrdenServicioTraslado = ({
  navigate,
  returnUrl
}: UseMutationsParams = {}) => {

  return useMutation({
    mutationFn: (data: UseUpdateParams<OrdenServicioTrasladoForm>) => {
      return putOrdenServicioTraslado(data);
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: ['traslado']
      });
      
      navigate && returnUrl && navigate(returnUrl);

      toast.success(res.message);
    },
    onError: (error) => {
      const data = toApiError(error)
      toast.error(data.message)
    },
    onSettled: () => {

    },
  });
};

export const putOrdenServicioTraslado = async ({
  id,
  data
}: UseUpdateParams<OrdenServicioTrasladoForm>) => {
  return put<OrdenServicioTraslado>(`${BASE_URL}/${id}/`, data, true);
};
